var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.mixes && _setup.mixes.length)?_c('div',[_c('BaseSection',{attrs:{"show-all-link":{ name: 'browse/mixes/trending' },"title":"Trending","reserve-subtitle":"","show-all-title":"Browse More"}},[_c(_setup.MixGridBlock,{attrs:{"mixes":_setup.mixes}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }